import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
export const Container = ({ children, size = 'medium', className = '', }) => {
    const sizeClass = `legarta-container--${size}`;
    return (_jsx(StyledContainer, { className: `legarta-container ${sizeClass} ${className}`, children: children }));
};
const StyledContainer = styled.div `
  margin: 0 auto;
  padding: 0 16px;
  width: 100%;
  box-sizing: border-box;

  &.legarta-container--small {
    max-width: 768px;
  }

  &.legarta-container--medium {
    max-width: 1024px;
  }

  &.legarta-container--large {
    max-width: 1280px;
  }

  &.legarta-container--full {
    max-width: none;
  }

  @media (max-width: 768px) {
    padding: 0 12px;
  }

  @media (max-width: 480px) {
    padding: 0 8px;
  }
`;
